import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "convert-to-language-group-primary-modal" */'./ConvertToLanguageGroupPrimaryModal').then(mod => mod.default),
  LoadingComponent: () => null
});